module.exports = __webpack_public_path__ + "img/arrow-down.a0acc03f.svg";